export const getConfirmationExpire = ({ signIn: { expiresIn } }) => expiresIn
export const getConfirmationIdentity = ({ signIn: { identity } }) => identity
